import ReactEcharts from "echarts-for-react"; // Import ECharts for React wrapper
import { AccumulatorChartDataList } from "../../interfaces/Accumulator";


const getOption = (series: Array<any>, x_labels: string[]) => {
    return {
        tooltip: {
            trigger: "axis",
        },
        legend: {
            data: ["Уровень заряда", "Разряд"],
            selectedMode: false,
        },
        xAxis: {
            type: "category",
            boundaryGap: true,
            data: x_labels, // Generates an array from 0 to 23
        },
        yAxis: [
            {
                type: "value",
                min: 0,
                max: 100,
                axisLabel: {
                    formatter: "{value}%", // Assuming values between 0 and 100
                },
            },
            {
            type: "value",
            min: 0,
            axisLabel: {
                // formatter: '{value} кВт', // Assuming values between 0 and 100
                formatter: function (value: any) {
                if (value > 1_000_000) {
                    return (value / 1_000_000).toFixed(1) + " млн кВтч";
                }
                if (value > 1_000) {
                    return (value / 1_000).toFixed(1) + " т кВтч";
                }
                return value.toFixed(1) + " кВтч";
                },
            },
            },
        ],
        series: series,
    };
};


export const SocChart = (
  x_labels: string[],
  chartData: AccumulatorChartDataList
) => {

  let series: Array<any> = []

  for (let item of chartData.soc_data.missing) {
    let data = {
      tooltip: {
        show: false
      },
      yAxisIndex: 0,
      type: "line",
      color: "#FF8200",
      smooth: true,
      data: item,
      lineStyle: {
        type: 'dashed',
        width: 2
      },
      symbol: "none",
      connectNulls: false,
      areaStyle: {
        origin: 'start',
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "rgba(255, 130, 0, 0.5)", // color at 0%
            },
            {
              offset: 1,
              color: "rgba(255, 130, 0, 0.2)", // color at 100%
            },
          ],
          global: false, // default is false
        },
      },
    }
    series.push(data)
  }

  series.push({
    name: "Уровень заряда",
    yAxisIndex: 0,
    symbol: "none",
    type: "line",
    color: "#FF8200",
    smooth: true,
    data: chartData.soc_data.data,
    connectNulls: false,
    areaStyle: {
      origin: 'start',
      color: {
        type: "linear",
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [
          {
            offset: 0,
            color: "rgba(255, 130, 0, 0.9)", // color at 0%
          },
          {
            offset: 1,
            color: "rgba(255, 130, 0, 0.2)", // color at 100%
          },
        ],
        global: false, // default is false
      },
    },
    tooltip: {
      valueFormatter: function (value: any) {
        if (value === undefined) {
          return "- %";
        }
        return value + " %";
      },
    },
  })
  series.push({
    name: "Разряд",
    yAxisIndex: 1,
    color: "#BABABA",
    type: "bar",
    data: chartData.energy_discharge_data.data.map((value, index) => {
      let prev = chartData.energy_discharge_data.data[index-1]
      let current = value

      if (index > 0 && prev !== undefined && current !== undefined && prev !== null && current !== null) {
          return (Math.abs((prev - current)))
      } else {
          return null
      }
    }),
    symbol: "none",
    tooltip: {
      valueFormatter: function (value: any) {
        if (value === undefined) { return "кВтч" }
        if (value > 1_000_000) {
          return (value / 1_000_000).toFixed(3) + " млн кВтч";
        }
        if (value > 1_000) {
          return (value / 1_000).toFixed(3) + " т кВтч";
        }
        return value.toFixed(3) + " кВтч";
      },
    },
  })

  const options = getOption(series, x_labels)
  return <ReactEcharts option={options}  notMerge={true} />;
};